import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData, postData } from '../../../apiService';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import CopyrightIcon from '@mui/icons-material/Copyright';
import AsyncSelect from 'react-select/async';
import generateRepairPDF from '../repairandreplacement/Bill';
import '../shared.css';

const RepairAndReplacementCreate = () => {
    const { id } = useParams();
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();
    const [selectedItemDescription, setSelectedItemDescription] = useState('0');
    const [selectedItemCategory, setSelectedItemCategory] = useState('0');
    const [selectedSalesMan, setSelectedSalesMan] = useState('');
    const [dropdownSalesManOptions, setDropdownSalesManOptions] = useState([]);
    const [selectedCardType, setSelectedCardType] = useState('');
    const [dropdownCardTypeOptions, setDropdownCardTypeOptions] = useState([]);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    useEffect(() => {
        fetchDropdownSalesManOptions();
        fetchDropdownCardTypeOptions();
        fetchmaxbillno();
        fetchItems();
    }, []);

    const fetchmaxbillno = () => {
        const currentDate = new Date();
        const formattedDate = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(currentDate.getDate()).padStart(2, '0')}`;
        fetchData('RepairAndReplacementApi', `/MaxBillno/${companyId}/${branchId}`, token)
            .then(r => r.response_data)
            .then(data => setFormData(prev => ({
                ...prev,
                BillNumber: data.BillNumber,
                BillPrefix: data.BillPrefix,
                BillDate: formattedDate,
                BranchId: branchId,
                CompanyId: companyId,
            })))
            .catch(err => console.error('Error fetching Max Billno', err));
    };

    const fetchDropdownSalesManOptions = () => {
        fetchData('RepairAndReplacementApi', `/SalesMan/${companyId}/${branchId}`, token)
            .then(r => r.response_data).then(data => setDropdownSalesManOptions(data))
            .catch(err => console.error('Error fetching SalesMan:', err));
    };

    const fetchDropdownCardTypeOptions = () => {
        fetchData('RepairAndReplacementApi', `/CardType/${companyId}/${branchId}`, token)
            .then(r => r.response_data).then(data => setDropdownCardTypeOptions(data))
            .catch(err => console.error('Error fetching CardType:', err));
    };

    const [formData, setFormData] = useState({});
    const [invoicedeatils, setInvoicedeatils] = useState([]);
    const [itemdetails, setItemDetails] = useState([]);
    const [itemsOptions, setItemsrOptions] = useState([]);
    const [selectedItems, setSelectedItem] = useState(null);

    const [modalData, setModalData] = useState({
        ReceiptType: '', ItemCategory: '', Amount: '',
        ReceiptTypeName: '', ItemCategoryName: '', ItemName: '', ItemId: '', Remarks: '',
    });

    const fetchItems = async () => {
        try {
            const response = await fetchData('PurchaseApi', `/Item/${companyId}/${branchId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(item => ({
                    value: item.Id,
                    label: item.Code + '-' + item.Name,
                }));
                setItemsrOptions(options);
                setItemDetails(response.response_data);
            }
        } catch (err) { console.error('Error fetching items:', err); }
    };

    const handleItemSelect = (selectedOption) => {
        setSelectedItem(selectedOption);
        setModalData(prev => ({
            ...prev,
            ItemName: selectedOption ? selectedOption.label : '',
            ItemId: selectedOption ? selectedOption.value : '',
        }));
    };

    const fetchOptions = async (inputValue) => {
        if (inputValue.length < 3) return [];
        const response = await fetchData('PurchaseApi', `/ItemSaleReturn/${companyId}/0/${inputValue}`, token);
        if (response.responseCode === '1111') {
            return response.response_data.map(item => ({
                value: item.Id,
                label: item.Code + '-' + item.Name,
            }));
        }
        return [];
    };

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        if (name === 'CardAmount') {
            const cardAmount = parseFloat(value) || 0;
            const Amount = invoicedeatils.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            totalCalculation(Amount, cardAmount, UPIAmount);
            setFormData(prev => ({ ...prev, CardAmount: cardAmount.toFixed(2), ModifiedBy: userId }));
        } else if (name === 'UPIAmount') {
            const upiAmount = parseFloat(value) || 0;
            const Amount = invoicedeatils.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            totalCalculation(Amount, CardAmount, upiAmount);
            setFormData(prev => ({ ...prev, UPIAmount: upiAmount.toFixed(2), ModifiedBy: userId }));
        } else {
            setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
        }
    };

    const handleModalInputChange = (e) => {
        const { name, value } = e.target;
        setModalData(prev => ({ ...prev, [name]: value }));
    };

    const totalCalculation = (Amount, CardAmount, UPIAmount) => {
        const totalAmt = parseFloat(Amount).toFixed(2);
        const cashamt = parseFloat(totalAmt - CardAmount - UPIAmount).toFixed(2);
        setFormData(prev => ({
            ...prev,
            TotalAmount: Amount.toFixed(2),
            CashAmount: parseFloat(cashamt).toFixed(2),
            CardAmount: CardAmount.toFixed(2),
            UPIAmount: UPIAmount.toFixed(2),
            ModifiedBy: userId,
        }));
    };

    const saveModalData = () => {
        let errors = '';
        if (selectedItemDescription == 0) errors = 'Item Description is required';
        else if (!modalData.ItemId) errors = 'Item is required';
        else if (selectedItemCategory == 0) errors = 'Item Category is required';
        else if (!modalData.Amount || isNaN(modalData.Amount)) errors = 'Amount must be a valid number';

        if (errors) { setErrorMessageModel(errors); return; }
        setErrorMessageModel('');

        const updatedInvoicedetails = [modalData, ...invoicedeatils];
        setInvoicedeatils(updatedInvoicedetails);

        const Amount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
        const CardAmount = parseFloat(formData.CardAmount) || 0;
        const UPIAmount = parseFloat(formData.UPIAmount) || 0;
        totalCalculation(Amount, CardAmount, UPIAmount);

        setModalData({ ReceiptType: '', ItemCategory: '', Amount: '', ReceiptTypeName: '', ItemCategoryName: '', ItemName: '', ItemId: '', Remarks: '' });
        setSelectedItemDescription('0');
        setSelectedItemCategory('0');
        setSelectedItem(null);
    };

    const removeRecord = (index) => {
        if (!window.confirm('Are you sure you want to remove the record?')) return;
        const updated = [...invoicedeatils];
        updated.splice(index, 1);
        setInvoicedeatils(updated);
        const Amount = updated.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
        const CardAmount = parseFloat(formData.CardAmount) || 0;
        const UPIAmount = parseFloat(formData.UPIAmount) || 0;
        totalCalculation(Amount, CardAmount, UPIAmount);
    };

    const handlePrint = async (SaleId) => {
        try {
            const response = await fetchData('RepairAndReplacementApi', `/SalePrint/${SaleId}/${branchId}`, token);
            generateRepairPDF(response.response_data);
        } catch (error) { console.error('Error printing Invoice:', error); }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);
        if (!formData.CustomerName) { setErrorMessage('Customer Name is required!'); setIsLoading(false); return; }
        if (formData.CashAmount < 0) { setErrorMessage('Cash Amount less than 0 is not allowed!'); setIsLoading(false); return; }
        if (formData.CardAmount > 0 && !formData.CardNumber) { setErrorMessage('Card Number is required when Card Amount > 0!'); setIsLoading(false); return; }
        if (formData.CardAmount > 0 && !selectedCardType) { setErrorMessage('Card Type is required when Card Amount > 0!'); setIsLoading(false); return; }
        if (!formData.ContactNumber) { setErrorMessage('Contact Number is required!'); setIsLoading(false); return; }
        if (!selectedSalesMan) { setErrorMessage('Sales Man is required!'); setIsLoading(false); return; }
        if (formData.UPIAmount > 0 && !formData.UPINumber) { setErrorMessage('UPI Number is required when UPI Amount > 0!'); setIsLoading(false); return; }
        if (!invoicedeatils || invoicedeatils.length === 0) { setErrorMessage('Item Details are required!'); setIsLoading(false); return; }

        const CreateData = {
            RepairAndReplacement: {
                ...formData,
                ModifiedBy: userId,
                BranchId: branchId,
                CompanyId: companyId,
                SalesManId: selectedSalesMan,
                CardType: (formData.CardAmount > 0 && selectedCardType) ? parseInt(selectedCardType) : null,
            },
            RepairAndReplacementDetails: invoicedeatils,
        };

        postData('RepairAndReplacementApi', CreateData, token)
            .then(response => {
                history.push('/Home');
                if (response.response === 'RepairAndReplacement Create Successfully') handlePrint(response.kotId);
            })
            .catch(err => { console.error('Error creating record:', err); setIsLoading(false); });
    };

    const formatDateForInput = (dateString) => {
        if (!dateString) return '';
        const d = new Date(dateString);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    };

    const asyncSelectStyles = {
        control: (base) => ({ ...base, minHeight: '28px', height: '28px', fontSize: '12.5px', borderColor: 'rgba(200,212,224,0.8)', borderRadius: '5px', boxShadow: 'none', '&:hover': { borderColor: '#c9a96e' } }),
        valueContainer: (base) => ({ ...base, height: '28px', padding: '0 8px' }),
        indicatorsContainer: (base) => ({ ...base, height: '28px' }),
        menu: (base) => ({ ...base, zIndex: 1301, fontSize: '12px' }),
    };

    return (
        <Fragment>
            <div className="pg-container">

                {/* ── Header ── */}
                <div className="pg-header">
                    <h5 className="pg-title">Repair / Replacement Receipt — Create</h5>
                    <div className="pg-header-actions">
                        <div className="pg-action-row">
                            <button className="pg-btn pg-btn-success" onClick={handleSubmit} disabled={isLoading}>
                                <DoneIcon /> {isLoading ? <CircularProgress size={14} color="inherit" /> : 'Save'}
                            </button>
                            <Link to="/Home" className="pg-btn pg-btn-danger">
                                <CloseIcon /> Cancel
                            </Link>
                        </div>
                    </div>
                </div>

                {errorMessage && <div className="pg-alert pg-alert-error">{errorMessage}</div>}
                {successMessage && <div className="pg-alert pg-alert-success">{successMessage}</div>}

                <div className="pg-card">

                    {/* ── Row 1: Customer / Address / Phone / Receipt Date / Receipt No ── */}
                    <div className="pg-hpanel">
                        <div className="pg-hcell" style={{ flex: '3 1 0' }}>
                            <span className="pg-hcell-label">Customer Name <span className="req">*</span></span>
                            <input className="pg-hcell-input" type="text" placeholder="Customer"
                                value={formData.CustomerName || ''} onChange={handleChange} name="CustomerName" maxLength={100} />
                        </div>
                        <div className="pg-hcell" style={{ flex: '2 1 0' }}>
                            <span className="pg-hcell-label">Address</span>
                            <input className="pg-hcell-input" type="text" placeholder="Address"
                                value={formData.CustomerAddress || ''} onChange={handleChange} name="CustomerAddress" maxLength={200} />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Phone No <span className="req">*</span></span>
                            <input className="pg-hcell-input" type="text" placeholder="Phone Number"
                                value={formData.ContactNumber || ''} onChange={handleChange} name="ContactNumber" maxLength={15} />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Receipt Date <span className="req">*</span></span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="date"
                                value={formatDateForInput(formData.BillDate)} onChange={handleChange} name="BillDate" readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '0 0 90px' }}>
                            <span className="pg-hcell-label">Receipt No <span className="req">*</span></span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text"
                                value={formData.BillNumber || ''} readOnly />
                        </div>
                    </div>

                    {/* ── Item add bar ── */}
                    <div className="pg-item-bar" style={{ marginTop: 10 }}>
                        <div className="pg-field" style={{ flex: '0 0 160px' }}>
                            <label className="pg-label">Item Description <span style={{ color: 'var(--pg-danger)' }}>*</span></label>
                            <select className="pg-select" value={selectedItemDescription}
                                onChange={e => {
                                    const v = e.target.value;
                                    setSelectedItemDescription(v);
                                    setModalData(prev => ({ ...prev, ReceiptType: v, ReceiptTypeName: e.target.options[e.target.selectedIndex].text || '' }));
                                }}>
                                <option value={0}>Select</option>
                                <option value={1}>Repair Receipt</option>
                                <option value={2}>Replacement Receipt</option>
                            </select>
                        </div>
                        <div className="pg-field" style={{ flex: '0 0 140px' }}>
                            <label className="pg-label">Item Category <span style={{ color: 'var(--pg-danger)' }}>*</span></label>
                            <select className="pg-select" value={selectedItemCategory}
                                onChange={e => {
                                    const v = e.target.value;
                                    setSelectedItemCategory(v);
                                    setModalData(prev => ({ ...prev, ItemCategory: v, ItemCategoryName: e.target.options[e.target.selectedIndex].text || '' }));
                                }}>
                                <option value={0}>Select</option>
                                <option value={1}>Jewellery</option>
                                <option value={2}>Watch</option>
                                <option value={3}>Crystal</option>
                                <option value={4}>Others</option>
                            </select>
                        </div>
                        <div className="pg-field" style={{ flex: '2 1 0' }}>
                            <label className="pg-label">Item Name</label>
                            <AsyncSelect
                                cacheOptions
                                value={selectedItems}
                                onChange={handleItemSelect}
                                options={itemsOptions}
                                loadOptions={fetchOptions}
                                placeholder="Search items…"
                                styles={asyncSelectStyles}
                            />
                        </div>
                        <div className="pg-field" style={{ flex: '2 1 0' }}>
                            <label className="pg-label">Remarks</label>
                            <input className="pg-input" type="text" maxLength={200} name="Remarks"
                                placeholder="Remarks" value={modalData.Remarks || ''} onChange={handleModalInputChange} />
                        </div>
                        <div className="pg-field" style={{ flex: '0 0 100px' }}>
                            <label className="pg-label">Amount</label>
                            <input className="pg-input text-right" type="number" name="Amount"
                                placeholder="0.00" value={modalData.Amount || ''} onChange={handleModalInputChange} />
                        </div>
                        <div style={{ paddingTop: 18 }}>
                            <button className="pg-btn pg-btn-primary" onClick={saveModalData}>
                                <AddIcon /> Add Item
                            </button>
                        </div>
                    </div>

                    {errorMessageModel && <div className="pg-alert pg-alert-error">{errorMessageModel}</div>}

                    {/* ── Invoice detail table ── */}
                    <div className="pg-invoice-table-wrap">
                        <table className="pg-invoice-table">
                            <thead>
                                <tr>
                                    <th>Item Description</th>
                                    <th>Item Category</th>
                                    <th>Item Details</th>
                                    <th>Remarks</th>
                                    <th className="right">Amount</th>
                                    <th className="right">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {invoicedeatils.length === 0 ? (
                                    <tr><td colSpan={6} style={{ textAlign: 'center', padding: 12, color: '#94a3b8' }}>No items added yet.</td></tr>
                                ) : (
                                    invoicedeatils.map((invdetail, index) => (
                                        <tr key={index}>
                                            <td>{invdetail.ReceiptTypeName}</td>
                                            <td>{invdetail.ItemCategoryName}</td>
                                            <td>{invdetail.ItemName}</td>
                                            <td>{invdetail.Remarks}</td>
                                            <td className="right">{invdetail.Amount}</td>
                                            <td className="right">
                                                <IconButton size="small" onClick={() => removeRecord(index)}>
                                                    <DeleteIcon style={{ color: '#dc2626', fontSize: 17 }} />
                                                </IconButton>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* ── Totals panel ── */}
                    <div className="pg-totals-panel">
                        {/* Left: Remarks + summary */}
                        <div className="pg-totals-left">
                            <div className="pg-totals-remarks">
                                <span className="pg-tsum-label">Remarks</span>
                                <input className="pg-remarks-textarea" type="text" placeholder="Remarks"
                                    value={formData.Remarks || ''} onChange={handleChange} name="Remarks" maxLength={200} />
                            </div>
                            <div className="pg-totals-summary">
                                <div className="pg-tsum-row">
                                    <span className="pg-tsum-label">Sales Man <span style={{ color: 'var(--pg-danger)' }}>*</span></span>
                                    <select className="pg-tpay-select" value={selectedSalesMan}
                                        onChange={e => { setSelectedSalesMan(e.target.value); setFormData(p => ({ ...p, SalesManId: e.target.value })); }}
                                        style={{ width: 130 }}>
                                        <option value="">Select</option>
                                        {dropdownSalesManOptions.map(o => <option key={o.Id} value={o.Id}>{o.Name}</option>)}
                                    </select>
                                </div>
                                <div className="pg-tsum-row">
                                    <span className="pg-tsum-label">Total</span>
                                    <span className="pg-tsum-value">{formData.TotalAmount || '0.00'}</span>
                                </div>
                            </div>
                        </div>

                        {/* Right: Grand Total + Payments */}
                        <div className="pg-totals-right">
                            <div className="pg-grand-total-bar">
                                <span className="pg-gt-label">Total Amount</span>
                                <span className="pg-gt-value">{formData.TotalAmount || '0.00'}</span>
                            </div>

                            <div className="pg-totals-pay-row">
                                <div className="pg-tpay-cell">
                                    <span className="pg-tpay-label">Cash <span className="req">*</span></span>
                                    <input className={`pg-tpay-input${formData.CashAmount < 0 ? ' cash-negative' : ''}`}
                                        type="text" value={formData.CashAmount || ''} readOnly />
                                </div>
                                <div className="pg-tpay-cell">
                                    <span className="pg-tpay-label">Card <span className="req">*</span></span>
                                    <input className="pg-tpay-input" type="text" name="CardAmount"
                                        value={formData.CardAmount || ''} onChange={handleChange} />
                                </div>
                                <div className="pg-tpay-cell">
                                    <span className="pg-tpay-label">UPI / RTGS / Other <span className="req">*</span></span>
                                    <input className="pg-tpay-input" type="text" name="UPIAmount"
                                        value={formData.UPIAmount || ''} onChange={handleChange} />
                                </div>
                            </div>

                            {(formData.CardAmount > 0 || formData.UPIAmount > 0) && (
                                <div className="pg-tpay-extra-row">
                                    {formData.CardAmount > 0 && (
                                        <div className="pg-tpay-cell">
                                            <span className="pg-tpay-label">Card Name <span className="req">*</span></span>
                                            <select className="pg-tpay-select" value={selectedCardType}
                                                onChange={e => { setSelectedCardType(e.target.value); setFormData(p => ({ ...p, CardType: e.target.value })); }}>
                                                <option value="">Select Card Type</option>
                                                {dropdownCardTypeOptions.map(o => <option key={o.Id} value={o.Id}>{o.Name}</option>)}
                                            </select>
                                        </div>
                                    )}
                                    {formData.CardAmount > 0 && (
                                        <div className="pg-tpay-cell">
                                            <span className="pg-tpay-label">Card Number <span className="req">*</span></span>
                                            <input className="pg-tpay-input" type="text" name="CardNumber"
                                                value={formData.CardNumber || ''} onChange={handleChange} maxLength={20} />
                                        </div>
                                    )}
                                    {formData.UPIAmount > 0 && (
                                        <div className="pg-tpay-cell">
                                            <span className="pg-tpay-label">UPI / RTGS / Other No. <span className="req">*</span></span>
                                            <input className="pg-tpay-input" type="text" name="UPINumber"
                                                value={formData.UPINumber || ''} onChange={handleChange} maxLength={20} />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>

                </div>{/* end pg-card */}

                <div className="pg-watermark"><CopyrightIcon style={{ fontSize: 12 }} /><b>EFFTABS SOLUTIONS LLP</b></div>

            </div>
        </Fragment>
    );
};

export default RepairAndReplacementCreate;
